import { axiosInstance } from ".."

const projectsCatlog = async (querry) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.get(`internal/projects/list?permission=1&projectSource=UTECH&${querry}`).then((res) => { 
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default projectsCatlog;